import { useAuthStore } from '@/store/auth.store';

export function usePermissions() {
  const hasPermission = useAuthStore((state) => state.hasPermission);
  const user = useAuthStore((state) => state.user);

  return {
    hasPermission,
    user,
    isAuthenticated: !!user,
  };
}

